import { FILTER_VALUE } from "utils/Constants";
import { AppURL } from "utils/Actions";

export const createStatusFilter = (filterObj: any) => {
  const newStatusFilter: Array<string | undefined> = [];

  filterObj.forEach((obj: any) => {
    if (obj[FILTER_VALUE.RATED]) {
      newStatusFilter.push(FILTER_VALUE.RATED);
    }
    if (obj[FILTER_VALUE.PARTIAL]) {
      newStatusFilter.push(FILTER_VALUE.PARTIAL);
    }
    if (obj[FILTER_VALUE.UNRATED]) {
      newStatusFilter.push(FILTER_VALUE.UNRATED);
    }
  });

  return newStatusFilter;
};

export const convertSorter = (order: string) => {
  return order == "asc" ? "ascend" : order == "desc" ? "descend" : undefined;
};

export const setSorter = (fieldName: string, sorter: any) => {
  return sorter?.field === fieldName ? convertSorter(sorter.dir) : undefined;
};

export const backToDashboard = (history: any) => {
  history.push("/school");
};

export const startRating = (history: any, refNum: string) => {
  history.push(`${AppURL.school.rater.ratings}/${refNum}`);
};
